import { queryOptions } from '@tanstack/react-query';

import { PRODUCT_QUERY_KEYS } from '@/entities/product/keys';
import type { IProductCodeOptions } from '@/entities/product/types';

import apiGetProductCode from '../apis/get_product_code';

export const productCodeOptions = ({ productCode, lng }: IProductCodeOptions) =>
  queryOptions({
    queryKey: [PRODUCT_QUERY_KEYS.GET_PRODUCT, productCode, lng],
    queryFn: () => apiGetProductCode({ productCode, lng }),
    retry: false,
    enabled: !!productCode && !!lng,
  });
